export { SUPPORT_EMAIL } from '../constants'

export type SupportValidationData = {
  fromEmail: string
  ccEmails: string
  subject: string
  supportText: string
  supportHTML: string
}

export enum SupportPageStatusT {
  default,
  success,
  error
}
